<template>
  <b-field class="letter-list">
    <b-radio-button v-model="selection"
                    v-for="letter in letters"
                    :native-value="letter"
                    :key="letter">
      <span>{{ letter }}</span>
    </b-radio-button>
  </b-field>
</template>

<script>
const ALPHABET = [
  'A',
  'B',
  'C',
  'D',
  'E',
  'F',
  'G',
  'H',
  'I',
  'J',
  'K',
  'L',
  'M',
  'N',
  'O',
  'P',
  'Q',
  'R',
  'S',
  'T',
  'U',
  'V',
  'W',
  'X',
  'Y',
  'Z'
]

export default {
  name: 'LetterBar',

  props: {
    value: {
      type: String
    }
  },

  created() {
    this.selection = this.value
  },

  data() {
    return {
      selection: null,
      letters: ALPHABET
    }
  },

  methods: {
    notify() {
      this.$emit('input', this.selection)
      this.$emit('selected', this.selection)
    }
  },

  watch: {
    selection: 'notify',
    value() {
      if (this.value !== this.selection) {
        this.selection = this.value
      }
    }
  }
}
</script>

<style scoped>
.letter-list {
  justify-content: space-between;
}
</style>
